export const CONTRACT_TYPES = ['Digital', 'Call', 'Put'] as const

export type ContractType = (typeof CONTRACT_TYPES)[number]

export const CONTRACT_TYPE_LABELS: Record<ContractType, string> = {
  Call: 'Call',
  Put: 'Put',
  Digital: 'Digital',
}

export const CONTRACT_TYPE_OPTIONS = CONTRACT_TYPES.map((t) => ({
  label: CONTRACT_TYPE_LABELS[t],
  value: t,
})).sort()
